import { ReactNode } from "react";

type Props = {
  className?: string;
  children?: ReactNode;
}

const DarkenBackground = ({ className, children }: Props) => (
  <>
    <div
      className="w-full h-full"
      style={{
        backgroundImage:
          'linear-gradient(rgba(0, 0, 0, 0) 0%, rgb(0 0 0 / 84%) 80%, rgb(0 0 0 / 72%) 100%), url(/login-background.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
    >
      <div className={className}>
        {children}
      </div>
    </div>
  </>
);

export default DarkenBackground;
